// extracted by mini-css-extract-plugin
module.exports = {"mobile":"360","tablet":"768","desktop":"1280","statusesSection":"_3S_bX","titre":"_2I9_9","description":"_1sr-D","link":"_2oYtL","icon":"_2XgQi"};